// eslint-disable-next-line no-unused-vars
export const ShopSingleProductStyles = (theme) => ({
	// ...styles(theme),
	shopSingleProductHeadline: {
		lineHeight: 1.1,
		hyphens: 'auto',
	},
	shopSingleProductOfferInfo: {
		'& p, span': {
			lineHeight: 1,
		},
	},
	shopSingleProductAssetGallery: {
		'& .MuiCardContent-root': {
			padding: theme.spacing(2),
		},
	},
	shopSingleProductTeaser: {
		marginBottom: theme.spacing(3),
	},
	shopSingleProductManufacturer: {
		marginBottom: theme.spacing(0.5),
	},
	shopSingleProductDescription: {
		fontSize: '1rem',
		'& .embed-responsive': {
			display: 'block',
			height: 0,
			overflow: 'hidden',
			padding: 0,
			position: 'relative',
		},
		'& .embed-responsive-16by9': {
			paddingBottom: '56.25%',
		},
		'& .embed-responsive-item': {
			border: 0,
			bottom: 0,
			height: '100%',
			left: 0,
			position: 'absolute',
			top: 0,
			width: '100%',
		},
		'& .copyright-info': {
			fontSize: '0.75em',
			fontStyle: 'italic',
		},
	},
	shopSingleProductDetails: {
		'& .MuiTableContainer-root': {
			overflowX: 'unset',
		},
		'&:last-child': {
			padding: 0,
		},
		'& .MuiTableCell-sizeSmall': {
			paddingLeft: 0,
		},
	},
});
